import {
  AccountMetricTile,
  absMoney,
  dueLabel,
  dueTone,
  effectiveDueHint,
  money,
  profitLabel,
  profitTone,
} from "./accountEditorUi";

/**
 * Compact financial snapshot — verification CTA lives in the header only.
 */
const AccountFinancialSummary = ({ totals }) => {
  const due = Number(totals?.totalDue || 0);
  const profit = Number(totals?.totalProfitLoss || 0);
  const commission = Number(totals?.totalCommission || 0);
  const showCommission = commission > 0;

  return (
    <div
      className={`grid grid-cols-2 gap-2 ${
        showCommission ? "sm:grid-cols-3 lg:grid-cols-5" : "lg:grid-cols-4"
      }`}
    >
      <AccountMetricTile label="Paid" value={money(totals?.totalPaid)} size="lg" emphasize />
      <AccountMetricTile label="Agent cost" value={money(totals?.totalCost)} size="lg" emphasize />
      {showCommission && (
        <AccountMetricTile
          label="Commission received"
          value={money(commission)}
          size="lg"
          emphasize
          tone="good"
        />
      )}
      <AccountMetricTile
        label={dueLabel(due)}
        value={absMoney(due)}
        tone={dueTone(due)}
        size="lg"
        emphasize
        hint={effectiveDueHint(due, totals?.totalEffectiveDue)}
      />
      <AccountMetricTile
        label={profitLabel(profit)}
        value={absMoney(profit)}
        tone={profitTone(profit)}
        size="lg"
        emphasize
      />
    </div>
  );
};

export default AccountFinancialSummary;
